import { render, staticRenderFns } from "./CommonWriteKwResult.vue?vue&type=template&id=56a98de8&scoped=true"
import script from "./CommonWriteKwResult.vue?vue&type=script&lang=js"
export * from "./CommonWriteKwResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWriteKwResult.vue?vue&type=style&index=0&id=56a98de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a98de8",
  null
  
)

export default component.exports